import { Autocomplete } from "@mui/material"
import React, { ChangeEvent, FormEvent } from "react"
import { ThemeProvider } from "styled-components"
import { CommonPopperProps } from "./CommonPopperProps"
import { Popper } from "./Popper"
import { PopperSaveButton } from "./PopperSaveButton"
import { PopperTextInput } from "./PopperTextInput"
import { PopperDarkTheme, PopperLightTheme } from "./popperThemes"

export type DropdownPopperProps<TValue = string> = CommonPopperProps & {
  inputLabel?: string
  options?: TValue[]
  formatOption?: (option: TValue) => string
  value: TValue
  helperText?: string
  onChange: (e: ChangeEvent<{}>, newValue: any) => Promise<void> | void
  onSubmit?: (newValue: TValue | undefined) => Promise<void> | void
}

export const DropdownPopper = (props: DropdownPopperProps) => {
  const {
    popperTitle,
    inputLabel,
    options = [],
    formatOption = (option) => option,
    value,
    helperText,
    onChange,
    onClose,
    onDelete,
    onSubmit,
    className,
    lightMode = false,
    anchorEl,
    anchorOrigin,
    transformOrigin,
    confirmText,
  } = props

  const handleSubmit = (e: React.MouseEvent<Element, MouseEvent> | FormEvent) => {
    e.preventDefault()
    onSubmit && onSubmit(value)
  }

  return (
    <ThemeProvider theme={lightMode ? PopperLightTheme : PopperDarkTheme}>
      <Popper
        title={popperTitle}
        onClose={onClose}
        onDelete={onDelete}
        anchorEl={anchorEl}
        className={className}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        <Autocomplete
          disableClearable
          options={options}
          getOptionLabel={formatOption}
          onChange={onChange}
          openOnFocus={false}
          renderInput={(params) => (
            <PopperTextInput
              {...params}
              value={value}
              variant="outlined"
              label={inputLabel}
              helperText={helperText}
              fullWidth
              $lightMode={lightMode}
            />
          )}
        />

        <PopperSaveButton onClick={handleSubmit}>{confirmText}</PopperSaveButton>
      </Popper>
    </ThemeProvider>
  )
}
